import { useCallback } from "react";
import { fetchMaterialSpecAutocompleteOptions } from "api";

export const useTemplateAutocomplete = () => {
    return useCallback(
        (queryName: string, searchValue: string) =>
            fetchMaterialSpecAutocompleteOptions({ field: "matspecname", value: searchValue }),
        []
    );
};
